import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RecipientRecord } from 'app/messages/message-service/message.model';


@Component({
  selector: 'app-email-recipient',
  templateUrl: './email-recipient.component.html',
  styleUrls: ['./email-recipient.component.scss']
})
export class EmailRecipientComponent implements OnInit {

  @Input() recipient: RecipientRecord;
  @Input() recipientType: string;
  @Output() removeRecipient = new EventEmitter<Object>();

  removable = true;
  primary='primary';

  ngOnInit(): void {}

  handleRemoveRecipient() {
    this.removeRecipient.emit({ recipientEmail: this.recipient.emailAddress, addressType: this.recipientType });
  }

}
